export function getAllAgreements(axiosPrivate) {
  return axiosPrivate.get('/v2/trade-data-agreement/list-agreements')
}

export function getOptionAgreements(axiosPrivate) {
  return axiosPrivate.get('/v2/trade-data-agreement/options')
}

export function getAgreementById(axiosPrivate, params) {
  const id = params.idAgreement
  return axiosPrivate.get(`/v2/trade-data-agreement/${id}`)
}

export function createAgreement(axiosPrivate, formData) {
  return axiosPrivate.post('/v2/trade-data-agreement/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function updateAgreementById(axiosPrivate, id, params) {
  return axiosPrivate.put(`/v2/trade-data-agreement/${id}/update`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function deleteAgreementChapter(axiosPrivate, id) {
  return axiosPrivate.delete(`/v2/trade-data-agreement/chapter/${id}/delete`)
}

export function exportAgreementDetail(axiosPrivate, id: string) {
  return axiosPrivate.get(`/v2/trade-data-agreement/export-detail/${id}`, {
    responseType: 'blob',
  })
}

export function submitReorderChapter(axiosPrivate, body) {
  return axiosPrivate.post('/v2/trade-data-agreement/chapter/edit-order', body)
}

export function verifySourceUrl(axiosPrivate, url) {
  return axiosPrivate.post('/v2/trade-data-agreement/verify-source-url', {url})
}
